import { FC, useMemo } from 'react';
// Models
import { IUsage } from 'app/store/ManagementBillingUsage/ManagementBillingUsage.models';
// Mui
import { Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Theme } from '@mui/material';
// Utils
import { toNumberWithCommas } from 'app/utilities/Utilities';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  data: IUsage[];
}

const UsageGroupByCaseAndService:FC<Props> = ({
  // Props
  data
}) => {
  const { t } = useTranslation();

  const totalAmount = useMemo(() => {
    return data.reduce((acc:number, cur) => acc + cur.amount, 0)
  }, [data]);

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>{t('labels.subscriptionPackage')}</TableCell>
            <TableCell>{t('labels.total')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((usage, index) => (
            <TableRow key={`tableRow-${usage.subscriptionPackage?.id}-${index}`}>
              <TableCell>{usage.subscriptionPackage?.name}</TableCell>
              <TableCell>{`$${toNumberWithCommas(usage.amount)}`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter sx={{ position: 'sticky', bottom: 0, backgroundColor: 'white', zIndex: 1 }}>
          <TableRow sx={{
            bgcolor: (theme:Theme) => theme.palette.grey[50],
            '& > td': {
              borderBottom: 0
            }
          }}>
            <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem' }}>{t('labels.total')}</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem' }}>{`$${toNumberWithCommas(totalAmount)}`}</TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}

export default UsageGroupByCaseAndService